import * as CardApplication from '@/src/experiences/card-application'

// eslint-disable-next-line
export const unstable_settings = {
  // Ensure that reloading on `/modal` keeps a back button present.
  initialRouteName: 'index',
}

export default CardApplication.Navigation.OnboardingLayout
